<ui-navbar></ui-navbar>

<div class="mx-auto max-w-7xl px-4 py-10">
    <div class="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
            <p class="mb-2 text-xs font-semibold uppercase tracking-wider text-primary">Account</p>
            <h1 class="!mb-1 !text-4xl !font-bold !tracking-tight !text-strong sm:!text-5xl">
                Area riservata
            </h1>
            <p class="!mb-0 !text-base !leading-relaxed !text-subtle sm:!text-lg">
                Gestisci i tuoi dati personali e i documenti richiesti dalla società.
            </p>
        </div>
    </div>

    <div class="profile-container">
        <section class="left-column">
            <div class="profile-details welldone-card overflow-hidden">
                <div class="profile-banner"></div>
                <div class="head-left-column">
                    <div class="profile-avatar" aria-hidden="true">{{ profileInitials }}</div>
                    <span class="user-name">{{ mister.firstName }} {{ mister.lastName }}</span>
                    <span class="user-email">{{ mister.email || 'Nessuna email registrata' }}</span>
                </div>
                <div class="body-left-column">
                    <div class="address-details" *ngIf="mister.phone || mister.address || mister.city">
                        <span class="detail-title">Contatti</span>
                        <span *ngIf="mister.phone">{{ mister.phone }}</span>
                        <span *ngIf="mister.address">{{ mister.address }}</span>
                        <span *ngIf="mister.city">{{ mister.city }} <ng-container *ngIf="mister.province">({{ mister.province }})</ng-container></span>
                    </div>
                </div>
            </div>

            <div class="link-account welldone-card mt-6">
                <div class="welldone-card-header">Dati personali</div>
                <div class="welldone-card-body">
                    <form #profileForm="ngForm" (ngSubmit)="saveProfile()">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">Nome</label>
                                <input type="text" class="form-control"
                                       name="firstName"
                                       [(ngModel)]="editableUser.firstName"
                                       required/>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Cognome</label>
                                <input type="text" class="form-control"
                                       name="lastName"
                                       [(ngModel)]="editableUser.lastName"
                                       required/>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Email</label>
                                <input type="email" class="form-control"
                                       name="email"
                                       [(ngModel)]="editableUser.email"
                                       required/>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Telefono</label>
                                <input type="text" class="form-control"
                                       name="phone"
                                       [(ngModel)]="editableUser.phone"/>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end w-100 mt-4">
                            <button type="submit"
                                    class="btn welldone-btn-light"
                                    [disabled]="profileForm.invalid || savingProfile">
                                {{ savingProfile ? 'Salvataggio...' : 'Salva modifiche' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>

        <section class="right-column">
            <div class="links-container">
                <div class="alert alert-danger alert-custom" role="alert"
                     *ngIf="missingCompanyDocuments.length">
                    <img src="assets/icons/chat-right-text.svg" alt="chat-icon">
                    <div class="alert-text">
                        <span class="fw-bold">
                            Mancano {{ missingCompanyDocuments.length }}
                            {{ missingCompanyDocuments.length === 1 ? 'documento richiesto' : 'documenti richiesti' }}
                            dalla società
                        </span>
                        <span>Da un controllo risultano mancare i seguenti documenti obbligatori:</span>
                        <ng-container *ngFor="let missingDoc of missingCompanyDocuments">
                            <span>
                                - {{ missingDoc.name }}
                                <ng-container *ngIf="missingDoc.description">({{ missingDoc.description }})</ng-container>
                            </span>
                        </ng-container>
                    </div>
                </div>

                <div class="welldone-card upload-card">
                    <div class="welldone-card-header d-flex align-items-center justify-content-between">
                        <span>Carica documento</span>
                        <span class="upload-hint">PDF o immagine</span>
                    </div>
                    <div class="welldone-card-body">
                        <form #documentUploadForm="ngForm">
                            <div class="row g-3">
                                <div class="col-12">
                                    <label class="form-label required mb-1">Tipo di documento</label>
                                    <select class="form-select form-control form-control-solid"
                                            [(ngModel)]="typeOfDocument"
                                            name="typeOfDocument"
                                            required
                                            (ngModelChange)="chooseModelDocument()">
                                        <option value="" selected>Seleziona tipologia</option>
                                        <option *ngFor="let document of companyDocuments" [ngValue]="document.id">
                                            {{ document.name }}
                                        </option>
                                    </select>
                                    <a *ngIf="typeOfDocument && selectedDocumentHasModelDocument"
                                       class="model-link"
                                       [href]="selectedDocumentModelUrl"
                                       target="_blank"
                                       rel="noopener">
                                        Scarica modello documento
                                    </a>
                                </div>

                                <div class="col-12" *ngIf="typeOfDocument && selectedDocumentDescription">
                                    <label class="form-label mb-1">Descrizione</label>
                                    <input type="text"
                                           class="form-control form-control-solid"
                                           [ngModel]="selectedDocumentDescription"
                                           [ngModelOptions]="{standalone: true}"
                                           readonly>
                                </div>

                                <div class="col-12">
                                    <label class="form-label required mb-1">Documento (fronte)</label>
                                    <input type="file"
                                           class="form-control form-control-solid"
                                           (change)="chooseDocument($event)"
                                           name="fileToUpload"
                                           required>
                                </div>

                                <div class="col-12">
                                    <label class="form-label mb-1">Documento (retro)</label>
                                    <input type="file"
                                           class="form-control form-control-solid"
                                           (change)="chooseDocument2($event)"
                                           name="fileToUploadBack"
                                           [disabled]="!file">
                                </div>

                                <div class="col-12" *ngIf="selectedDocumentHasExiration">
                                    <label class="form-label required mb-1">Data di scadenza</label>
                                    <input type="date"
                                           class="form-control form-control-solid"
                                           [(ngModel)]="expirationDate"
                                           name="expirationDate"
                                           required/>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="welldone-card-footer d-flex justify-content-end">
                        <button class="btn btn-primary"
                                (click)="uploadDocument()"
                                [disabled]="documentUploadForm.invalid || uploadingDocument">
                            {{ uploadingDocument ? 'Caricamento...' : 'Carica documento' }}
                        </button>
                    </div>
                </div>

                <div class="uploaded-documents">
                    <div class="section-heading">
                        <h2>Documenti caricati</h2>
                        <span class="section-count" *ngIf="userCompanyDocuments.length">
                            {{ userCompanyDocuments.length }}
                        </span>
                    </div>

                    <ng-container *ngIf="userCompanyDocuments.length; else noDocumentsUploaded">
                        <div class="document-grid">
                            <article class="welldone-card document-card" *ngFor="let userDocument of userCompanyDocuments">
                                <button type="button"
                                        class="document-preview"
                                        (click)="downloadDocument(userDocument.UserCompanyDocument?.url)"
                                        [attr.aria-label]="'Apri ' + userDocument.name">
                                    <img src="assets/icons/pdf.svg" alt="" class="document-image"/>
                                </button>
                                <div class="document-meta">
                                    <span class="document-name">{{ userDocument.name }}</span>
                                    <span class="welldone-text-gray upload-time">{{ userDocument.uploadTime }}</span>
                                    <span class="document-expiry"
                                          *ngIf="userDocument.UserCompanyDocument?.expirationDate">
                                        Scadenza: {{ userDocument.UserCompanyDocument!.expirationDate | date:'dd/MM/yyyy' }}
                                    </span>
                                </div>
                                <div class="document-actions">
                                    <button type="button"
                                            class="btn welldone-btn-primary"
                                            (click)="editDocument(userDocument)"
                                            aria-label="Modifica documento">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                             class="bi bi-pencil" viewBox="0 0 16 16">
                                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                        </svg>
                                    </button>
                                    <button type="button"
                                            class="btn welldone-btn-danger"
                                            (click)="deleteUserDocument(userDocument.id)"
                                            aria-label="Elimina documento">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-trash"
                                             viewBox="0 0 16 16">
                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                        </svg>
                                    </button>
                                </div>
                            </article>
                        </div>
                    </ng-container>

                    <ng-template #noDocumentsUploaded>
                        <div class="empty-documents welldone-card">
                            <img src="assets/icons/pdf.svg" alt="" class="empty-icon"/>
                            <p class="mb-0 fw-semibold">Nessun documento caricato</p>
                            <p class="mb-0 text-subtle">Carica il primo documento usando il modulo qui sopra.</p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </section>
    </div>
</div>

<ngx-smart-modal #editDocumentModal identifier="editDocumentModal" [closable]="true">
    <div class="wisper-card">
        <div class="wisper-card-header">Modifica documento</div>
        <div class="wisper-card-body">
            <form #editDocumentForm="ngForm">
                <div class="row g-3">
                    <div class="col-12">
                        <label class="form-label">Tipo di documento</label>
                        <input type="text" class="form-control form-control-solid"
                               [value]="editData.documentName" readonly>
                    </div>
                    <div class="col-12" *ngIf="editData.description">
                        <label class="form-label">Descrizione</label>
                        <input type="text" class="form-control form-control-solid"
                               [(ngModel)]="editData.description" name="editDescription" readonly>
                    </div>
                    <div class="col-12" *ngIf="editData.hasExpiration">
                        <label class="form-label required">Data di scadenza</label>
                        <input type="date" class="form-control form-control-solid"
                               [(ngModel)]="editData.expirationDate"
                               name="editExpirationDate"
                               required/>
                    </div>
                </div>
            </form>
        </div>
        <div class="wisper-card-footer d-flex justify-content-end">
            <button class="btn btn-primary"
                    (click)="saveEditedDocument()"
                    [disabled]="editDocumentForm.invalid">
                Salva modifiche
            </button>
        </div>
    </div>
</ngx-smart-modal>
